import React from "react";
import PropTypes from "prop-types";
import { isBreakpoint } from "../utility/WindowSizeHooks"
import PublicCatalogLayout from "../layouts/PublicCatalogLayout"
import { isJaguar } from "../utility/UserUtils";
import InventoryFormModal from "./forms/InventoryFormModal";
import OutlinedTable from "@/layouts/tables/OutlinedTable";
import SuperFilter from "../layouts/superfilter/SuperFilter";
class InventoryManagementDashboard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      editingRenterId: null,
      editingRenter: false,
      superFilters: [],
    }

    this.editRenter = this.editRenter.bind(this);
  }

  renderSuperFilter () {
    return(
      <>
        <br/>
        <br/>
        <SuperFilter
          urlLock={true}
          search={true}
          disableLabel={true}
          onChange={(filters) => {
            this.setState({superFilters: filters});
          }}
          id={`orders-list-superfilter`}
          lockable
          filters={[
            {
              id: "search",
              type:"search",
              options: [],
              outerClassName: "sg-super-filter-search-field-option-spacing",
              placeholder: "Search",
              name: "Search"
            }
          ]}
        />
      </>
    )
  }




  renderInventories(){
    const { renters } = this.props;
    return renters.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    })
    .map(inventory =>(
      <tr>
        <td>
          <a href={`/inventory/${inventory.id}`}>
            {inventory.name}
          </a>
        </td>
        <td>{this.getFullSquareFootage(inventory)}</td>
        {isJaguar(this.props.user) ? <td> <a href={`/warehouse/reports/renter_full_billing?id=${inventory.id}`} target="_blank" className="">.xls Report</a> </td> : ""}
        <td>${Number(inventory.monthly_cost||0).toFixed(2)}</td>
        <td>${this.getRentersFullPrice(inventory)}</td>
        {isJaguar(this.props.user) ? <td>
          <button className="btn-outlined" onClick={() => this.editRenter(inventory.id)}>Edit</button>
          </td> : ""}
      </tr>
    ))
  }

  editRenter(id){
    this.setState({editingRenterId: id, editingRenter: true})
  }


  getRentersFullPrice(renter){
    const price = Number(renter.monthly_cost||0);
    return (price * 12).toFixed(2);
  }



  renderHeaderRow() {
    return (
      <tr className="users-users-table-header-row">
        <th> Name </th>
        <th> Cubic Footage Volume (to nearest cuft)</th>
        {isJaguar(this.props.user) ? <th> Report </th> : ""}
        <th> Monthly Storage Cost </th>
        <th> Annual Storage Cost </th>
        {isJaguar(this.props.user) ? <th> Actions </th> : ""}
        
      </tr>
    );
  }

  getFullSquareFootage(renter){
    const size = Number(renter.stored_volume||0);
    return Math.round(size/1728)
  }

  renderActions() {
    if(isJaguar(this.props.user)) {
      return (
        <div className="row">
          <div className="col-xs-12">
            <button onClick={() => this.setState({ editingRenter: true, editingRenterId: null})} className="btn-outlined">
              Add Client
            </button>
          </div>
        </div>
      );
    }
  }


  renderFormModal() {
    const { editingRenterId, editingRenter } = this.state;
    if(isJaguar(this.props.user)) {
      return (
        <InventoryFormModal
          user={this.props.user}
          id={editingRenterId}
          open={editingRenter}
          onClose={() => {
            this.setState({ editingRenter: false, editingRenterId: null }); 
          }}
        />
      );
    }
  }


  getData() {
    const { superFilters } = this.state;
    let { renters } = this.props;

    superFilters.forEach(filterObject =>{
      renters = renters.filter(x=> {
        const nameContains = (x.name||"").toLowerCase().indexOf((filterObject.filterValue||"").toLowerCase()) != -1
        return nameContains
      })
    })
    return renters.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    })
  }

  getColumns() {
    return [
      {
        id: "name",
        label:"Name",
        renderCell: (row, column) => {
          return <a href={`/inventory/${row.id}`}>{row.name}</a>;
        }
      },
      {
        id: "volume",
        label:"Cubic Footage Volume (to nearest cuft)",
        valueGetter: (row, column) => {
          return this.getFullSquareFootage(row)
        },
      },
      {
        id: "report",
        label:"Report",
        renderCell: (row, column) => {
          return <a href={`/warehouse/reports/renter_full_billing?id=${row.id}`} target="_blank" className="">.xls Report</a>
        },
        sorting: false,
        hidden: !isJaguar(this.props.user)
      },
      {
        id: "actions",
        label:"Actions",
        renderCell: (row, column) => {
          return (
            <button className="btn-outlined" onClick={() => this.editRenter(row.id)}>Edit</button>
          );
        },
        sorting: false,
        hidden: !isJaguar(this.props.user)
      }
    ].filter(column => !column.hidden);
  }


  render() {
    return (
      <PublicCatalogLayout
        classNames={{container: 'inventory-dashboard'}}
        className="inventory-management-dashboard"
        currentPage=""
        {...this.props}
      >
        {this.renderFormModal()}
        <div className="row">
          <div className="col-xs-12">
            <h1 class="catalog-h1">Clients</h1>
          </div>
        </div>

        {this.renderActions()}
        {this.renderSuperFilter()}
        <div className="row">
          <div className="col-xs-12">
            <div className="table-responsive">
              <OutlinedTable
                loading={false}
                columns={this.getColumns()}
                rows={this.getData()}
              />
            </div>
          </div>
        </div>
      </PublicCatalogLayout>
    );
  }
}

InventoryManagementDashboard.propTypes = {

};

export default InventoryManagementDashboard;
